$(function() {
    $(".js-contact-gallery").lightGallery(
        $.extend({}, lightGallerySettings, {
            selector: ".js-lightgallery"
        })
    );
});